import { userActions } from '../_actions';

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function handleResponse(response) {
    return response.text().then(text => {
        const data = isJson(text) ? text && JSON.parse(text) : text;
        if (!response.ok) {
            if (response.status === 401) {
                userActions.logout();
            }
            console.log('DATA', data)
            let complexText;
            if(data && data[""] && data[""].length > 0){
                complexText = data[""][0];
            }

            let error = [];
            if(data && (data.message || data.Message)){
                if(data.message && data.message !== ""){
                    error.push(data.message)
                }
                if(data.Message && data.Message !== ""){
                    error.push(data.Message)
                }
            }
            if(response.statusText && complexText){
                error.push(response.statusText + ': ' + complexText)
            }
            else if(response.statusText && response.statusText !== "") {
                error.push(response.statusText)
            }
            // const error = (data && (data.message || data.Message)) || (response.statusText && complexText ? response.statusText + ': ' + complexText : response.statusText); 
            return Promise.reject(error.join(', '));
        }

        return data;
    });
}